import { apiRequest } from '@/endpoints/axiosInstance'
import { HttpMethod } from '@/endpoints/utils'
import { requireSelectedBranchId } from '@/pages/User/pages/Home/components/TreePanel/branchSelectionStorage'

export const getNodeData = async <T>(nodeId: number) => {
	try {
		const response = await apiRequest<T>({
			url: `/branch/${requireSelectedBranchId()}/structure/${nodeId}`,
			method: HttpMethod.GET,
		})

		return response
	} catch (error) {
		console.error(error)
	}
}
